import './App.css';
import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/login';
import Search from './components/search';
import Loading from './components/loading';
import PublicLayout from './components/public-layout';
import ProtectedLayout from './components/protected-layout';


function App() {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // TEST MODE - Set to true to bypass authentication
  const TEST_MODE = false;

  // Check authentication status on load
  useEffect(() => {
    if (TEST_MODE) {
      // Skip auth check and set as authenticated
      setIsAuthenticated(true);
      setUser({ user: 'TestUser' });
      setLoading(false);
      return;
    }

    fetch('https://banner.infosys.etsu.edu/NodeCasServer/api/session-data', {
      credentials: 'include' // Important for sessions
    })
    .then(res => res.json())
    .then(data => {
      if (data.sessionID && data.userID) {
        setIsAuthenticated(true);
        setUser(data.userID);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error('Auth check failed:', err);
      setLoading(false);
    });
  }, [TEST_MODE]);

  const handleLogin = () => {
    // Redirect to backend CAS login
    window.location.href = 'https://banner.infosys.etsu.edu/NodeCasServer/authenticate?returnTo=https://banner.infosys.etsu.edu/VoyagerIndexLookup/search';
  };

  return (
    <div className="App">
      <Routes>
        {/* Default route - redirects based on auth status */}
        <Route
          path="/VoyagerIndexLookup/"
          element={
            loading ? (
              <Loading />
            ) : isAuthenticated ? (
              <Navigate to="/VoyagerIndexLookup/search" replace />
            ) : (
              <Navigate to="/VoyagerIndexLookup/login" replace />
            )
          }
        />

        {/* Public routes */}
          <Route
            path="/VoyagerIndexLookup/"
            element={
              <PublicLayout
                isAuthenticated={isAuthenticated}
                loading={loading}
                onLogin={handleLogin}
              />
            }
          >
         <Route path="/VoyagerIndexLookup/login" element={<Login />} />
        </Route>

        {/* Protected routes */}
        <Route
          path="/VoyagerIndexLookup/"
          element={
            <ProtectedLayout
              isAuthenticated={isAuthenticated}
              loading={loading}
              user={user}
            />
          }
        >
          <Route path="/VoyagerIndexLookup/search" element={<Search />} />
          {/* add more protected routes here */}
          {/* <Route path="profile" element={<Profile />} /> */}
          {/* <Route path="settings" element={<Settings />} /> */}
        </Route>

        {/* Catch all route - redirect to home */}
        <Route path="*" element={<Navigate to="/VoyagerIndexLookup/" replace />} />
      </Routes>
    </div>
  );
}

export default App;